import { BaseEntityDTO, BaseEntitySchema } from '@hexcrawl/shared-utils';
import { requestJson } from '@/ui/services/api';

export const enemyService = {
  async getEnemy(id: string): Promise<BaseEntityDTO> {
    const url = `/game/enemy?id=${encodeURIComponent(id)}`;
    return requestJson<BaseEntityDTO>({
      url,
      method: 'GET',
      schema: BaseEntitySchema,
    });
  },
};
